import { Controller } from "@hotwired/stimulus"

export default class NewModalController extends Controller {
  static targets = ["closeButton"]

  connect() {
    this.element.modal = this;
    document.addEventListener("turbo:before-cache", this.close.bind(this));
  }

  closeOnEscape = (e) => {
    if (e.key === 'Escape') {
      this.close();
    }
  };

  open() {
    this.previouslyFocusedElement = document.activeElement;
    this.element.classList.add('--open');
    this.loadDeferredContent();
    document.addEventListener('keyup', this.closeOnEscape);
    document.body.style.overflow = "hidden";
    if (this.hasCloseButtonTarget) this.closeButtonTarget.focus();
  }

  // A lazy frame only loads once the browser reports it as visible, which it
  // never does while the modal is hidden. Fetch on open instead.
  loadDeferredContent() {
    this.element.querySelectorAll('turbo-frame[loading="lazy"]').forEach((frame) => {
      frame.setAttribute('loading', 'eager');
    });
  }

  close() {
    this.element.classList.remove('--open');
    document.removeEventListener('keyup', this.closeOnEscape);
    document.body.style.overflow = "auto";
    this.previouslyFocusedElement?.focus();
  }

  handleBackgroundClick(e) {
    if ( e.target === e.currentTarget ){
      this.close();
    }
  }
}
